// extracted by mini-css-extract-plugin
export default {"loader":"index_loader__CZ+OG","dot":"index_dot__UcW0B","dotter":"index_dotter__eKpJK","glow":"index_glow__1DEu9"};